import { PlayArrowFill } from "@material-symbols-svg/react";
import React, { useState } from "react";
import VideoPlayerModal from "../../modals/common/VideoPlayerModal";

interface VideoCardProps {
  title: string;
  description: string;
  duration: string;
  videoUrl: string;
  thumbnailUrl: string;
}

const CGMVideoTutorialCard: React.FC<VideoCardProps> = ({
  title,
  description,
  duration,
  videoUrl,
  thumbnailUrl,
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div className="relative">
      <div className="flex items-start gap-3">
        <div className="flex-1">
          <h3 className="font-roboto font-bold text-[16px] leading-[120%] tracking-[0.25px]">
            {title}
          </h3>
          <p className="text-sm font-roboto  font-normal text-[14px] leading-[150%] tracking-[0.25px] text-[#667085] mt-1">
            {description}
          </p>
          <p className="text-xs text-gray-500 mt-2">{duration}</p>
        </div>
        <button
          className="w-36 h-36 bg-gray-200 rounded-lg relative flex-shrink-0 overflow-hidden"
          onClick={() => setShowModal(true)}
        >
          <img
            src={thumbnailUrl}
            alt="Video thumbnail"
            className="w-full h-full object-cover rounded-lg"
          />
          <div
            className="absolute bottom-2 right-2 cursor-pointer bg-[var(--app-primary)] rounded-full p-2"
            style={{
              boxShadow: "0 0 10px 0 rgba(0, 0, 0, 0.1)",
            }}
          >
            {/* <img src={PlayIcon} className="w-15 h-15 text-gray-800 ml-0.5" /> */}
            <PlayArrowFill className="w-15 h-15 text-white ml-0.5" />
          </div>
        </button>
      </div>
      <VideoPlayerModal
        show={showModal}
        title={title}
        handleClose={() => setShowModal(false)}
        videoUrl={videoUrl}
        type="youtube"
      />
    </div>
  );
};

export default CGMVideoTutorialCard;
